<ng-container
  [ngTemplateOutlet]="
    inEmailForm ? emailForm : inCodeForm ? codeForm : passwordForm
  "
>
</ng-container>

<ng-template #emailForm>
  <app-email-form (emailFormSuccess)="handleEmailForm()" />
</ng-template>

<ng-template #codeForm>
  <app-code-form
    (codeFormSuccess)="handleCodeForm()"
    (codeFormBack)="handleCodeFormBack()"
  />
</ng-template>
<ng-template #passwordForm>
  <app-password-form (passwordFormBack)="handlePasswordFormBack()" />
</ng-template>
